// Аккаунт: сведения для «Дашборда» и «Настроек», выход и удаление.
import { api, getJson } from "../api";

export type Usage = { used: number; limit: number };
export type Me = {
  kind: "guest" | "registered"; name: string; email: string; created_at: string;
  logins: { provider: string; email: string; created_at: string }[];
  usage: { assistant: Usage; documents: Usage };
};

export const loadMe = () => getJson<Me>("/api/me");

export const PROVIDERS: Record<string, string> = { google: "Google", yandex: "Яндекс ID", email: "Код на почту" };

// Выход — обычной формой: сервер снимает cookie и возвращает на ту же страницу.
export function logout() {
  const form = document.createElement("form");
  form.method = "post";
  form.action = "/auth/logout";
  document.body.append(form);
  form.submit();
}

export async function deleteAccount() {
  if (!confirm("Удалить аккаунт вместе со всеми чатами, документами, расчётами и папками? Отменить это нельзя.")) return;
  try {
    await api("/api/me", undefined, "DELETE");
    location.href = "/";
  } catch (error) {
    alert((error as Error).message);
  }
}
